import React, { Component, PropTypes } from 'react';
import { prefixLink } from 'gatsby-helpers';

import Wrapper from 'components/wrapper';
import { Link } from 'react-router';
import TweenMax from 'gsap'

import styles from './styles.module.css';

export default class ProjectPanel extends Component {
  static propTypes = {
    project: PropTypes.object,
    id: PropTypes.number,
  };


  componentDidMount (prevProps, prevState){

    var multiple = (this.props.id % 2 == 0) ? -1 : 1
    var xStart = 500 * multiple

    TweenMax.set(this.panelItem, {x: xStart})

    TweenMax.fromTo(this.panelItem, 3, {x: xStart}, {x: 0})
  }

  render() {
    const { project } = this.props;

    const textStyle = (project.slug== 'incruizer') ? {color:' black'} : {color: 'white'}

    return (
      <Link to={prefixLink(`/work/${project.slug}/`)} className={styles[project.className]}>
        <Wrapper >
          <div  className={styles.inner}>
            <div  ref={c => this.panelItem = c } className={styles.content}>
              <h1 style={textStyle}>{project.title}</h1>
              <p><h3 style={textStyle}>{project.description}</h3></p>
            </div>
          </div>
        </Wrapper>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ../components/project/panel/index.jsx